module.exports = __webpack_public_path__ + "static/media/Colors Of Autumn-01.11d2f35f.svg";